import { type InfringementListQuery } from '@/shared/graphql/router/graphql'
import { useUserStore } from '@/shared/stores/user'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'
import { openModal, Modals } from '@/shared/dialogs/modals'

export type FlaggedInfringement =
  InfringementListQuery['infringements']['edges'][number]['node']

export const useFlaggedMatch = (infringement: FlaggedInfringement) => {
  const userStore = useUserStore()

  const handleCreate = () => {
    if (!userStore.user?.reportCredits) {
      return openDialog(Dialog.BuyReportCredits, {
        props: {
          afterPurchase: () =>
            openDialog(Dialog.FlaggedMatch, { props: { infringement } }),
        },
      })
    }

    openModal(Modals.ConfirmReportCreation, {
      stack: true,
      props: { infringement },
    })
  }

  return { handleCreate }
}
